import { LABEL_MANAGEMENT_MODAL_TYPE, LabelManagementModalType } from './shared-modal';

export const LABELS = {
	CANCEL_BUTTON_TEXT: 'Cancel',
	SAVE_BUTTON_TEXT: 'Save'
} as const;

export const MODAL_DESCRIPTIONS: Record<LabelManagementModalType, string> = {
	[LABEL_MANAGEMENT_MODAL_TYPE.ADD]:
		"Select the label key and value to add. Labels will only be added if they aren't already applied to the test. You can add multiple labels before saving.",
	[LABEL_MANAGEMENT_MODAL_TYPE.UPDATE]:
		'Select the label to update and the new value. You can update multiple labels before saving.',
	[LABEL_MANAGEMENT_MODAL_TYPE.REMOVE]:
		'Select the label to remove. You can remove multiple labels before saving.'
};
export const MODALS_LABELS = {
	ADD_LABEL_TYPE_SELECT_PLACEHOLDER: 'Select a label type',
	ADD_LABEL_TYPE_SELECT_TOOLTIP: 'Select which type of label you want to add',

	ADD_LABEL_VALUE_SELECT_PLACEHOLDER: 'Select value',
	ADD_LABEL_VALUE_SELECT_TOOLTIP: 'Select the value for the label'
};
export const MODAL_ACTION_TITLES: Record<LabelManagementModalType, string> = {
	[LABEL_MANAGEMENT_MODAL_TYPE.ADD]: 'Add label',
	[LABEL_MANAGEMENT_MODAL_TYPE.REMOVE]: 'Remove label',
	[LABEL_MANAGEMENT_MODAL_TYPE.UPDATE]: 'Update label'
};
export const MODAL_ACTION_MESSAGES = {
	LABEL_ADDITION_PROGRESS_MESSAGE: 'Adding labels',
	LABEL_ADDITION_ERROR_MESSAGE: 'Failed to add labels',
	LABEL_REMOVAL_PROGRESS_MESSAGE: 'Removing labels',
	LABEL_REMOVAL_ERROR_MESSAGE: 'Failed to remove labels',
	LABEL_UPDATE_PROGRESS_MESSAGE: 'Updating labels',
	LABEL_UPDATE_ERROR_MESSAGE: 'Failed to update labels'
};

export const MODAL_ACTION_ACTIONS: Record<LabelManagementModalType, string> = {
	[LABEL_MANAGEMENT_MODAL_TYPE.ADD]: 'to',
	[LABEL_MANAGEMENT_MODAL_TYPE.REMOVE]: 'from',
	[LABEL_MANAGEMENT_MODAL_TYPE.UPDATE]: 'for'
};

export const LABELS_ACTION_BUTTON_LABELS = {
	ADD: 'Add label',
	CHANGE: 'Change label value',
	REMOVE: 'Remove label'
} as const;
